const doc = [({"da":({"js":({"admin":({"sheet_layouts":({"select":({"choose_sheet_layout":"Vælg arkopsætning"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;